import type { BrowserAiToolsFilterableField } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import { BROWSER_AI_TOOLS_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/shadow-ai-browser-tools';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

/** Personal browser-tools filterable fields = org set minus the dropped Users column. */
export type PersonalBrowserAiToolsFilterableField = Exclude<
  BrowserAiToolsFilterableField,
  | typeof BROWSER_AI_TOOLS_FILTERABLE_FIELDS.USERS
  // Logged-in-user is an org-only column (KIR-2916); not shown in personal view.
  | typeof BROWSER_AI_TOOLS_FILTERABLE_FIELDS.LOGGED_IN_USER
  // KIR-5098: endpoint filter is org-only too.
  | typeof BROWSER_AI_TOOLS_FILTERABLE_FIELDS.ENDPOINT
>;

export const PERSONAL_BROWSER_AI_TOOLS_FILTER_URL_KEYS = {
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.DOMAIN]: 'dom',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.NAME]: 'n',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.TREND]: 'tr',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.FIRST_DETECTED]: 'fd',
  [BROWSER_AI_TOOLS_FILTERABLE_FIELDS.LAST_SEEN]: 'ls',
} as const satisfies Record<PersonalBrowserAiToolsFilterableField, string>;

export const PERSONAL_BROWSER_AI_TOOLS_TABLE_CONFIG = {
  tableId: TABLE_IDS.PERSONAL.SHADOW_AI.BROWSER,
} as const;
